module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Wide Angle + Telephoto + High Pixel Triple Camera.489975f3.png";